import { useState } from "react";
import DataTable from "react-data-table-component";
import { ChevronDown } from "react-feather";
import defaultImg from "@src/assets/images/noimage.png";
import themeConfig from "../../../../configs/themeConfig";
import ReactPaginate from "react-paginate";
import TableLoading from "../../../../@core/components/base/TableLoading";
import { Badge, Card, CardTitle, CardHeader, CardBody } from "reactstrap";
import { Fragment } from "react";

const UnitsTab = ({ property }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [units, setUnits] = useState(property.units);

  const columns = [
    {
      name: "unit",
      sortable: true,
      sortField: "phone",
      selector: (row) => row.building?.name ?? "",
      cell: (row) => (
        <div className="d-flex align-items-center">
          <div className="avatar rounded">
            <div className="avatar-content">
              <img
                src={
                  row.photos.length
                    ? `${themeConfig.serverUrl}uploads/${row.photos[0]}`
                    : defaultImg
                }
                className="w-100 h-100 object-fit-scale"
                alt={row?.name}
              />
            </div>
          </div>
          <div className="ms-2">
            <div className="fw-bolder ">
              {/* {property.name} {">"}  */}
              {row?.name}
            </div>
            <div className="font-small-2 text-muted">
              {/* <div className="d-flex ">
                <p>{ row.bathRooms} Bathrooms</p>
                <p>{ row.rooms} Rooms</p>
              </div> */}
            </div>
          </div>
        </div>
      ),
    },
    {
      name: "Rent Fee",
      sortable: true,
      sortField: "price",
      selector: (row) => row.building?.name ?? "",
      cell: (row) => <div className="">${row?.price ?? 0}</div>,
    },
    {
      name: "Reservation Fee",
      sortable: true,
      sortField: "price",
      selector: (row) => row.building?.name ?? "",
      cell: (row) => <div className="">${row?.reservationFee ?? 0}</div>,
    },
    {
      name: "Status",
      sortable: true,
      sortField: "price",
      selector: (row) => row?.status ?? "",
      cell: (row) => (
        <Badge
          color={
            row.status == "Available"
              ? "success"
              : row.status == "Booked"
              ? "warning"
              : "danger"
          }
        >
          {row.status}
        </Badge>
      ),
    },
  ];

  const handlePagination = (page) => {
    console.log(page);
    const startIndex = page * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;

    const currentPageData = property.units.slice(startIndex, endIndex);

    setUnits(currentPageData);
    setCurrentPage(page.selected + 1);
  };

  const CustomPagination = () => {
    const count = Number(Math.ceil(units / rowsPerPage));

    return (
      <ReactPaginate
        previousLabel={""}
        nextLabel={""}
        pageCount={count || 1}
        activeClassName="active"
        forcePage={currentPage !== 0 ? currentPage - 1 : 0}
        onPageChange={(page) => handlePagination(page)}
        pageClassName={"page-item"}
        nextLinkClassName={"page-link"}
        nextClassName={"page-item next"}
        previousClassName={"page-item prev"}
        previousLinkClassName={"page-link"}
        pageLinkClassName={"page-link"}
        containerClassName={
          "pagination react-paginate justify-content-end my-2 pe-1"
        }
      />
    );
  };

  const dataToRender = () => {
    return units;
  };

  return (
    <Fragment>
      <Card>
        <CardHeader tag="h4">
          <CardTitle> Units List</CardTitle>
          {/* <Button color="primary">New Agreement</Button> */}
        </CardHeader>
        <CardBody>
          <div className="react-dataTable user-view-account-projects">
            {property.units.length === 0 ? (
              <h5>No Data</h5>
            ) : (
              <DataTable
                sortServer
                pagination
                responsive
                paginationServer
                striped
                columns={columns}
                // onSort={handleSort}
                sortIcon={<ChevronDown />}
                className="react-dataTable react-dataTable-selectable-rows"
                paginationComponent={CustomPagination}
                data={dataToRender()}
                progressPending={!property.units.length}
                progressComponent={<TableLoading rows={1} cols={7} />}
                // selectableRowsComponent={Boos}
              />
            )}
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default UnitsTab;
